import { includes } from "lodash";
import { getAppUrl } from "@linkfluence/konf";
import { App } from "@linkfluence/models/app";
import { Timezone } from "@linkfluence/models/timezone";
import { getUrl } from "@tootools/query-string";
import { Project } from "@radarly/models/project";
import { SearchableWorkspace, Workspace } from "@radarly/models/workspace";
import { IRouterService } from "@radarly/shared/router";
import { getLandingUrl } from "@radarly/shared/router/landing";
import { Page } from "@radarly/shared/router/pages";
import {
  getNotImplementedPageUrl,
  getRouteFromPage,
} from "@radarly/shared/router/route";

function isPageImplemented(page: Page) {
  return includes(
    [
      Page.insightPagesList,
      Page.insightPagesHome,
      Page.insightPagesPage,
      Page.insightPagesGlobalPage,
      Page.insightPagesEditor,
      Page.insightPagesGlobalEditor,
      Page.insightPagesWizardEditor,
      Page.discovery,
      Page.imageClustering,
    ],
    page
  );
}

const getUrlParams = (
  page: Page,
  projectId: number,
  workspaceId: number,
  params: object = {}
) => {
  const urlParams = {
    project: projectId,
    ...params,
  } as Record<string, unknown>;
  if (page === Page.insightPagesHome) {
    urlParams.searchWorkspaceId = workspaceId;
  } else {
    urlParams.dashboard = workspaceId;
  }
  return urlParams;
};

export class CustomRouterService implements IRouterService {
  public getWorkspaceUrlFromPage(
    page: Page,
    project: Project,
    workspaceId: number,
    params: Record<string, any> = {}
  ) {
    const { timezone, ...baseParams } = params;
    const url = getUrl(
      this.getPathFromPage(page),
      getUrlParams(page, project.id, workspaceId, baseParams)
    );
    if (isPageImplemented(page)) {
      return url;
    } else {
      return getNotImplementedPageUrl(url);
    }
  }
  public getSettingsUrl(project: Project, path: string = "") {
    return (
      getAppUrl(App.RadarlySettings) +
      `#/project/${project.id}` +
      path +
      `?origin=${encodeURIComponent(window.location.href)}`
    );
  }
  public getSocialWallUrl(project: Project) {
    return getAppUrl(App.SocialWall) + "?project=" + project.id;
  }
  public getPathFromPage(page: Page) {
    return getRouteFromPage(page);
  }

  public getProjectUrlFromPage(
    project: Project,
    page: Page,
    params: object = {}
  ) {
    return getUrl(this.getPathFromPage(page), {
      project: project.id,
      ...params,
    });
  }

  public getLandingPage(
    currentProject: Project,
    currentWorkspaces: Workspace[],
    searchableWorkspace: SearchableWorkspace[],
    projects: Project[],
    timezone: Timezone
  ) {
    return getLandingUrl(
      this,
      Page.insightPagesList,
      currentProject,
      currentWorkspaces,
      searchableWorkspace,
      projects,
      timezone
    );
  }
}
